/**
 * Product Image Gallery Navigation
 * Handles arrow navigation for product image galleries on desktop
 */

function productImageDesktopArrow() {
  const mediaWrapper = document.querySelector('.product__media-wrapper');
  if (!mediaWrapper) return;

  const arrows = mediaWrapper.querySelectorAll('.slider-mobile-gutter .slider-arrow');

  arrows.forEach(function(arrow) {
    arrow.addEventListener('click', function() {
      const thumbnailWrapper = mediaWrapper.querySelector('.thumbnail-list');
      if (!thumbnailWrapper) return;

      const currentButton = thumbnailWrapper.querySelector('.thumbnail-list__item button[aria-current="true"]');
      if (!currentButton) return;

      const direction = arrow.getAttribute('name');

      if (direction === 'next') {
        const nextElement = currentButton.parentElement.nextSibling;
        if (nextElement) {
          const nextButton = nextElement.querySelector('button');
          if (nextButton) nextButton.click();
        }
      } else {
        const prevElement = currentButton.parentElement.previousSibling;
        if (prevElement) {
          const prevButton = prevElement.querySelector('button');
          if (prevButton) prevButton.click();
        }
      }
    });
  });
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
  productImageDesktopArrow();
});
